import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { IssueService } from '../../../../services/issue.service';
import { ActivatedRoute, Route, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'issues-loan-grid-item',
    templateUrl: './issues-loan-grid-item.component.html'
})
export class IssuesLoanGridItemComponent implements OnDestroy {


    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService
    ) {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['loanPage']) {
                    this.page = +queryParams['loanPage'];
                }

            }));

        this.issueService.issuePaygGetLoansPaged(this.clientId, this.page, this.siteId, this.pageSize).then(
            result => {
                this.dataService.issuesLoanGridItemComponentResolved.next(result.items.length > 0);
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
            },
            error => {
                this.dataService.issuesLoanGridItemComponentResolved.next(false);
            }
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());

    }

    getPage(page: number) {
        this.page = page;
        this.issueService.issuePaygGetLoansPaged(this.clientId, page, this.siteId, this.pageSize).then((result) => {
            this.data = [];
            this.data = result.items;
            this.totalPages = result.totalPages;
            this.pageSize = result.pageSize;
        });
    }

    onInfoClick() {
        swal({
            title: 'Loan provided in the last 90 days',
            html: '<p style="text-align: left;">This widget highlights consumers that have had a loan provided on their PAYG account in the last 90 days, along with the total of loans received since account opening.</p>\
                   <p style="text-align: left;">Consumers who request loans frequently may be having difficulty budgeting for their utility expenses or are unsure of the available top-up options. These consumers pose a debt risk to your organisation and you should encourage consumers to maintain healthy levels of PAYG credit on their device.</p>\
                   <p style="text-align: left;">You may wish to speak to consumers who request loans frequently to see if they need assistance. For consumers who you feel pose a debt risk to you, you can request that we cease to issue loans.</p>\
                   <p style="text-align: left;">Speak to us to discuss how to reduce the number of loans provided on your portfolio.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
